import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import UserDefaultAvatar from "assets/img/user.svg";
import classNames from "classnames";
import Scrollbar from "react-scrollbars-custom";

const styles = {
  avatarIcon: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    borderRadius: "50%",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "15px 0",
    borderBottom: "3px solid #73859f",
    borderTop: "3px solid #73859f",
  },
  content: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#434343f2",
    fontWeight: 400,
    fontSize: "16px",
  },
  list: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "16px",
    fontWeight: 500,
    paddingBottom: "10px",
    color: "green",
  },
};

export default ({ allMembersOnline, children, memberCount }) => {
  const classes = styles;
  const [showAllActiveMembersDialog, setActiveDialog] = useState(false);

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  return (
    <>
      <div
        className={classNames({
          memberWidth: true,
        })}
        onClick={() => setActiveDialog(true)}
      >
        {children}
      </div>
      <Modal
        open={showAllActiveMembersDialog}
        onClose={() => setActiveDialog(false)}
        showCloseIcon={false}
        classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
      >
        <div className="modalHeader">All Active Members</div>
        <Scrollbar
          style={{
            width: "calc(100vh - 366px)",
            overflow: "hidden",
            height: "calc(100vh - 329px)",
          }}
        >
          <div className="modalContent">
            <div style={classes.root}>
              {allMembersOnline?.map((member, key) => (
                <React.Fragment key={key}>
                  <div key={key} style={classes.list}>
                    <img
                      style={classes.avatarIcon}
                      onError={checkSrc}
                      src={
                        member?.state?.attributes?.avatar ?? UserDefaultAvatar
                      }
                      alt={`${member?.state?.attributes?.avatar}`}
                    />
                    <span style={classes.content}>
                      {member?.state?.attributes?.full_name}
                    </span>
                    <span>Active</span>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </Scrollbar>
        <div className="modalAction">
          <Button
            onClick={() => setActiveDialog(false)}
            buttonClass={"btn small-btn"}
          >
            Okay
          </Button>
        </div>
      </Modal>
    </>
  );
};
